<template>
    <div class="min-h-[400px] w-full px-4 py-6">
        <div
            :class="['max-w-[1600px] mx-auto rounded-3xl overflow-hidden bg-gradient-to-b from-white/70 to-white/100 shadow-lg', outerMarginClass]">
            <h1
                class="w-full pt-2 pb-3 mb-2 text-2xl font-bold leading-tight text-center text-[#17408B] tracking-tight">
                Staff Jurusan
            </h1>
            <div class="flex flex-col items-center justify-center gap-6 md:flex-row md:gap-0">
                <div v-for="(item, idx) in normalized" :key="item.id || idx"
                    class="relative flex-1 flex flex-col items-center justify-end h-[240px] md:h-[300px] lg:h-[340px] overflow-hidden rounded-2xl bg-white">
                    <!-- Foto -->
                    <img :src="fotoUrl(item.foto, item.nama)" :alt="`Foto ${item.nama || 'Pegawai'}`"
                        class="object-contain object-center w-full h-full bg-gray-100" />
                    <!-- Overlay gradient + text -->
                    <div
                        class="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-2xl">
                        <div class="p-8 pb-6">
                            <div
                                class="mb-1 text-lg font-bold leading-snug text-center text-white md:text-xl line-clamp-3">
                                {{ item.nama || '-' }}
                            </div>
                            <div class="mb-6 text-sm font-medium leading-tight text-center text-white md:text-base">
                                {{ item.jabatan?.name || '-' }}
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from "vue";

// Props: menerima object { data: [...] } sesuai contoh
const props = defineProps({
    pegawaiList: {
        type: [Object, Array],
        required: true,
    },
    outerMargin: { // Tailwind margin utilities e.g. 'mt-4 mb-6'
        type: String,
        default: 'my-4'
    }
});
// Note: mapping mengikuti struktur { id, nama, foto, jabatan: { name }, ... }

const normalized = computed(() => {
    if (Array.isArray(props.pegawaiList)) return props.pegawaiList;
    if (props.pegawaiList && Array.isArray(props.pegawaiList.data)) return props.pegawaiList.data;
    return [];
});

const outerMarginClass = computed(() => props.outerMargin);

// Helper for foto url (use your own logic if needed)
function fotoUrl(foto, nama = "User") {
    if (!foto) {
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(nama)}&background=e5e7eb&color=6b7280&size=256`;
    }
    if (/^https?:\/\//.test(foto) || foto.startsWith("/storage")) {
        return foto;
    }
    return "/storage/" + foto;
}
</script>

<style scoped>
.rounded-3xl {
    border-radius: 2rem;
}
</style>